<script>
import wootConstants from 'dashboard/constants/globals';

export default {
  props: {
    headerTitle: { type: String, default: '' },
    headerContent: { type: String, default: '' },
    headerDocumentation: { type: String, default: '' },
  },
  data() {
    return {
      channelName: this.$route.params.sub_page,
      channelDocs: wootConstants.CHANNEL_DOCS,
    };
  },
};
</script>

<template>
  <div class="flex flex-col w-full items-start">
    <h2
      class="text-xl font-medium mb-1 text-slate-800 dark:text-slate-100 break-words"
    >
      {{ headerTitle }}
    </h2>
    <p
      v-dompurify-html="headerContent"
      class="text-sm w-full text-slate-600 dark:text-slate-300"
    />
  </div>
</template>
